import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Popover from 'react-bootstrap/Popover';
import styled, { css } from 'styled-components/macro';
import { Button } from '@tovia/man-ui/lib/components/Button/Button';
import { NavLink } from 'react-router-dom';
import { DESKTOP, TABLET_PORTRAIT } from '@tovia/man-ui';
import { MOBILE_LANDSCAPE, TABLET_LANDSCAPE } from 'src/client/constants/mediaQueries';

export const Container = styled.div<{ extended?: boolean }>`
  a,
  i {
    transition: 0.3s color;
  }

  .image-btn,
  a:not(.btn):not(.active),
  .navbar-nav > li > a {
    color: ${(props) => props.theme.headerBarPrimary2};

    &:hover {
      text-decoration: none;
      color: ${(props) => props.theme.headerBarPrimary4};
    }
  }

  ${(props) =>
    props.extended &&
    css`
      overflow: hidden;
    `}
`;

export const NavbarIcon = styled(FontAwesomeIcon)`
  font-size: 2rem;
  vertical-align: middle;
  text-decoration: none;

  :hover & {
    text-decoration: none;
    color: ${(props) => props.theme.headerBarPrimary4};
  }
`;

export const NavbarHoverButton = styled.div`
  transition: 0.3s color;
  color: ${(props) => props.theme.headerBarPrimary2};

  &:hover {
    text-decoration: none;
    color: ${(props) => props.theme.headerBarPrimary4};

    ${NavbarIcon} {
      text-decoration: none;
      color: ${(props) => props.theme.headerBarPrimary4};
    }
  }
`;

export const ImageButton = styled(NavbarHoverButton)`
  position: relative;
  vertical-align: baseline;
  padding: 5px;
  text-align: center;

  @media ${MOBILE_LANDSCAPE} {
    padding: 7px;
  }

  @media ${DESKTOP} {
    padding: 10px;
  }

  i {
    transition: color 0.3s;
    vertical-align: middle;
  }
`;

export const FlatPopover = styled(Popover)`
  background: ${(props) => props.theme.primary1};
  border-color: ${(props) => props.theme.primary3};
  border-width: 1px;
  border-style: solid;
  border-radius: 2px;
  padding: 0;

  .popover-content {
    padding: 0;
  }
`;

export const NestedMenuLink = styled.div`
  order: 1;

  i {
    display: flex;
    width: 30px;
    justify-content: center;
    font-size: 2.15rem;
    margin-right: 10px;
  }

  > span {
    display: flex;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: ${(props) => props.theme.primary3};
    color: ${(props) => props.theme.headerBarPrimary2};
    padding: 10px;
    align-items: center;
  }

  a:first-of-type {
    border-top: 1px solid ${(props) => props.theme.primary3};
  }
`;

export const MobileMenuCaretWrapper = styled.div`
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const MobileMenuIcon = styled(FontAwesomeIcon)`
  display: flex;
  font-size: 1.55rem;
  margin-right: 10px;
  width: 1.25em !important;
  height: 25px;
  align-items: center;

  path {
    width: 22px;
  }
`;

export const MobileMenuButton = styled.div`
  transition: 0.3s color;
  font-size: 20px;
  vertical-align: middle;
  padding: 10px;
  color: ${(props) => props.theme.primary7};
  width: min-content;

  @media ${TABLET_PORTRAIT} {
    margin-left: -10px;
  }

  @media ${TABLET_LANDSCAPE} {
    display: none;
  }
`;

export const HeaderBarWrapper = styled.div`
  background: ${(props) => props.theme.headerBarPrimary1};
  position: sticky;
  top: 0;
  z-index: 1001;
  border-bottom: 1px solid ${(props) => props.theme.footerBarPrimary4};

  .sign-in {
    text-transform: capitalize;
  }

  .white-caret-down,
  .caret-down {
    font-size: 0.6rem;
  }

  .white-caret-down.live-girls-caret {
    margin-left: 6px;
  }

  .caret-down.live-girls-caret {
    margin-left: 6px;
  }

  .btn-site-picker .white-caret-down {
    position: relative;
  }

  .header-enter {
    max-width: 0;
    overflow: hidden;
  }

  .header-enter.header-enter-active {
    max-width: 280px;
    transition: max-width 500ms ease-in;
  }

  .header-leave {
    max-width: 280px;
  }

  .header-leave.header-leave-active {
    max-width: 0;
    overflow: hidden;
    transition: max-width 500ms ease-in;
  }

  .main-header {
    border-style: none;
    min-height: 64px; /* to keep guest and user headerbar same height */
    background: ${(props) => props.theme.headerBarPrimary1};
    z-index: 1030;

    @media (max-width: 991px) {
      background: ${(props) => props.theme.headerBarPrimary5};
    }
  }

  .main-header.navbar {
    margin-bottom: 0;
  }

  .container {
    .mobile-menu {
      .zEWidget-launcher {
        display: none;
      }
    }
  }

  .fa {
    vertical-align: middle;
  }

  [data-site='gn'] .logo img {
    @media (min-width: 480px) {
      max-height: 60px;
    }
  }

  .lang-symbol {
    text-transform: uppercase;
  }

  .i18n-popover {
    .lang-icon {
      margin-right: 5px;
    }
  }

  .popover-user-menu {
    max-width: none;

    .bottom {
      margin-left: -10px;
      margin-top: 22px;

      .arrow {
        margin-left: 20px;
        margin-top: 1px;
      }
    }
  }

  .popover-site-picker {
    max-width: none;
    position: fixed;
    top: 42px !important;

    .bottom {
      margin-top: 24px;

      .popover-content {
        padding: 0;
      }
    }
  }

  .popover-flat {
    border-width: 1px;
    border-style: solid;
    border-radius: 2px;
    padding: 0;

    .popover-content {
      padding: 0;
    }
  }

  .man-popover {
    position: absolute;
    z-index: 9999;
    top: calc(100% - 3px);
    left: 50%;
    border-radius: 1px;
    transform: translateX(-50%);

    .man-arrow {
      content: '';
      height: 0;
      width: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 10px solid ${(props) => props.theme.primary3};
      position: absolute;
      left: calc(50% - 5px);
      top: -10px;
      &.dark-man-arrow {
        border-bottom-color: ${(props) => props.theme.primary3};
      }
    }
  }
`;

export const BackButton = styled(Button)`
  background: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  display: flex;
  width: 100%;
  align-items: center;
  height: 20px;
  white-space: nowrap;
  margin: 10px 0 10px 0;
  padding: 0 0 0 10px;

  .back-icon {
    margin-right: 10px;
  }
`;

export const NewBadge = styled.div`
  color: white;
  font-size: 0.6rem;
  border-radius: 10px;
  padding: 0 2px;
  background-color: ${(props) => props.theme.headerBarPrimary2};
  margin-left: 10px;
`;

export const HoverMenuLink = styled.a`
  cursor: pointer;
  display: block;
  font-size: 0.9rem;
  height: 64px;
  line-height: 64px;
  padding: 0 13px;
  text-transform: uppercase;

  @media (max-width: 1199px) {
    font-size: 0.85rem;
  }
`;

const menuNavLinkCSS = css`
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  padding: 0 5px;
  font-size: 12px;
  color: ${(props) => props.theme.headerBarPrimary2};
  transition: 0.3s color;

  &:hover,
  &:focus {
    text-decoration: none;
    color: ${(props) => props.theme.headerBarPrimary4};
  }

  &.active {
    background-color: ${(props) => props.theme.headerBarPrimary3};
    color: ${(props) => props.theme.primaryBtn1Text};
  }

  @media ${DESKTOP} {
    padding: 0 10px;
  }
`;

export const MenuNavLink = styled(NavLink)`
  ${menuNavLinkCSS}
`;
export const MenuNavSpan = styled.span`
  ${menuNavLinkCSS}
`;
export const MenuNavAnchor = styled.a`
  ${menuNavLinkCSS}
`;

export const HoverMenuCaret = styled(FontAwesomeIcon)`
  margin-left: 2.5px;

  @media (max-width: 1399px) {
    display: none;
  }
`;

export const LogoLink = styled(NavLink)`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  margin-right: auto;
`;

export const LogoImage = styled.img`
  max-width: 110px;
  max-height: 45px;
  pointer-events: none;
  user-select: none;

  @media ${TABLET_PORTRAIT} {
    max-height: 50px;
    max-width: 205px;
  }
`;

export const HeaderFlexContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  width: 100%;
  min-height: 50px;

  @media ${TABLET_PORTRAIT} {
    min-height: 64px;
  }
`;
